import { useAuth0 } from '@auth0/auth0-react';
import Router from 'next/router';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Error from '@/pages/_error';
import { checkAccess } from '@/src/shared/constants';

import LoadingPage from '../LoadingPage/LoadingPage';

const isBrowser = typeof window !== 'undefined';

const withMembershipAccessWrap = (PageComponent, memberLevels, ssr = false) => {
  return function PageComponentWithAccess(props) {
    const { loginWithRedirect, isLoading } = useAuth0();
    const { isLoggedIn, role } = useSelector(state => state.auth);
    const stateLoading = useSelector(state => state.auth.isLoading);
    const personId = useSelector(state => state.auth.userinfo.PersonID);

    useEffect(() => {
      if (!stateLoading && !isLoggedIn) {
        loginWithRedirect({
          appState: {
            returnTo: Router.pathname,
          },
        });
      }
    }, [isLoggedIn, stateLoading]);

    const hasAccess = checkAccess(memberLevels, role);
    const isAuthorized = personId && Array.isArray(role) && hasAccess;
    const errorCode = isLoggedIn && !hasAccess ? 401.4 : 401;

    if (!ssr || isBrowser) {
      if (isLoading || stateLoading) return <LoadingPage />;
      if (!stateLoading && !isLoggedIn) {
        loginWithRedirect({
          appState: {
            returnTo: Router.pathname,
          },
        });
      }
      if (!stateLoading && isLoggedIn && !isAuthorized) return <Error status={errorCode} />;
    }

    return <PageComponent {...props} />;
  };
};

export const mapStateToProps = state => {
  const {
    auth: {
      isLoggedIn,
      isLoading,
      role,
      userinfo: { PersonID },
    },
  } = state;
  return {
    isLoggedIn,
    isLoading,
    role,
    personId: PersonID,
  };
};

export default withMembershipAccessWrap;
